var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-wizard-overview-description" },
    [
      _vm.template.pieces && _vm.template.pieces.length > 0
        ? _c("AutomationPieces", { attrs: { pieces: _vm.template.pieces } })
        : _vm._e(),
      _vm._v(" "),
      _vm.template.title
        ? _c(
            "h2",
            {
              staticClass:
                "automation-wizard-overview-description__title typographies-heading-h2"
            },
            [_vm._v("\n        " + _vm._s(_vm.template.title) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.template.description
        ? _c(
            "p",
            {
              staticClass:
                "automation-wizard-overview-description__description typographies-paragraph-medium-regular"
            },
            [_vm._v("\n        " + _vm._s(_vm.template.description) + "\n    ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }